import { MetricsPage } from "./MetricsPage";

const pages = {
  MetricsPage,
};
export default pages;
